module.exports = __webpack_public_path__ + "static/media/gradientbackground.b6498758.png";